<!--SHOWS IF MORE THAN 1 TESTIMONIAL-->
<ng-container *ngIf="testimonials && testimonials.length > 0">
  <section [ngClass]="testimonialBackgroundCSS ? testimonialBackgroundCSS : ''">
    <ngu-carousel #myCarousel [inputs]="testimonialBanner" [dataSource]="testimonials">
      <!--LEFT CAROUSEL ARROW-->
      <i
        NguCarouselPrev
        *ngIf="testimonials && testimonials.length > 1"
        class="left-slider icon small arrow-left cursor"
        [ngClass]="arrowColorCSS ? arrowColorCSS : ''"
        [style.opacity]="myCarousel.isFirst ? 0.5 : 1"></i>
      <!--END LEFT CAROUSEL ARROW-->
      <ngu-item *nguCarouselDef="let item; index as i; let ani = animate">
        <!--CAROUSEL CONTENT START-->
        <div class="testimonial-banner">
          <div class="wrapper" [ngClass]="testimonialWrapperCSS ? testimonialWrapperCSS : ''">
            <!--QUOTE BACKGROUND ICON-->
            <i class="icon black quote x-large margin-right-small"></i>
            <!--END QUOTE BACKGROUND ICON-->

            <!--TESTIMONIAL CONTENT START-->
            <figure [ngClass]="testimonialAlignmentCSS ? testimonialAlignmentCSS : ''">
              <!--OPTIONAL TITLE-->
              <span class="testimonial-title bold">{{ item?.title }}</span>
              <!--END OPTIONAL TITLE-->
              <!--REQUIRED QUOTE-->
              <blockquote>
                <q>{{ item?.quote }}</q>
              </blockquote>
              <!--END REQUIRED QUOTE-->
              <figcaption class="margin-bottom-small bolder">
                <!--NGCONTENT PRESENT IF AUTHOR AND JOB TITLE IS AVAILABLE-->
                {{ item?.author }}
                <ng-container *ngIf="item?.job_title">{{ item?.job_title }}</ng-container>
              </figcaption>
              <!--OPTIONAL COMPANY INFO-->
              <span class="bold">{{ item?.company }}</span>
              <!--END OPTIONAL COMPANY INFO-->
              <!--BUTTON TO SHOW EXTERNAL LINK -->
              <div>
                <a
                  *ngIf="item?.external_url"
                  href="{{ item?.external_url }}"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  class="btn btn-primary">
                  {{ item?.external_link_cta }}
                </a>
              </div>
              <!--END BUTTON TO SHOW EXTERNAL LINK -->
            </figure>
            <!--END TESTIMONIAL CONTENT -->

            <!--OPTIONAL TESTIMONIAL ICON START-->
            <!--NOTE: Make sure icon and text are centered align-->
            <div class="testimonial-icon text-align-center">
              <i class="icon red {{ item?.icon }} x-large"></i>
              <span class="margin-top-small">{{ item?.icon_name }}</span>
              <!--TODO: Enable icons to be read in from WordPress CMS-->
              <!-- <img
                *ngIf="item?.icon"
                [src]="item?.icon?.sizes?.thumbnail"
                [alt]="item?.icon?.alt" />-->
            </div>
            <!--END OPTIONAL TESTIMONIAL ICON -->
          </div>
        </div>
        <!--CAROUSEL CONTENT END-->
      </ngu-item>
      <!--RIGHT CAROUSEL ARROW-->
      <i
        NguCarouselNext
        *ngIf="testimonials && testimonials.length > 1"
        class="right-slider icon small arrow-right cursor"
        [ngClass]="arrowColorCSS ? arrowColorCSS : ''"
        [style.opacity]="myCarousel.isLast ? 0.5 : 1"></i>
      <!--END RIGHT CAROUSEL ARROW-->
      <!--CAROUSEL DOT NAVIGATION BUTTONS-->
      <!--NOTE: Clicking on dots takes you to a specific slide. If there is only 1 slide, hide this dot navigation.-->
      <ul class="myPoint cursor" NguCarouselPoint *ngIf="testimonials && testimonials.length > 1">
        <li
          *ngFor="
            let i of myCarousel.pointNumbers();
            let j = index;
            trackBy: trackByTestimonialIndex
          "
          [ngClass]="i === myCarousel.activePoint ? carouselDotActiveCSS : ''"
          (click)="myCarousel.moveTo(i)"></li>
      </ul>
      <!--END CAROUSEL DOT NAVIGATION BUTTONS-->
    </ngu-carousel>
  </section>
</ng-container>
